import { render, staticRenderFns } from "./PositionSelect.vue?vue&type=template&id=2c2d582d&scoped=true&"
import script from "./PositionSelect.vue?vue&type=script&lang=js&"
export * from "./PositionSelect.vue?vue&type=script&lang=js&"
import style0 from "./PositionSelect.vue?vue&type=style&index=0&id=2c2d582d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2d582d",
  null
  
)

export default component.exports